import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftIcon } from '../components/icons/NavIcons';
import { BuildingIcon, LocationIcon, MailIcon } from '../components/icons/NavIcons';
import PageHeader from '../components/PageHeader';

const ContactPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 pb-20">
      <PageHeader title={t('contact.title')} />

      {/* Contenu du contact */}
      <div className="p-4">
        <div className="bg-white rounded-lg shadow p-6">
          <div className="space-y-6">
            {/* Informations de contact */}
            <section>
              <h2 className="text-h2 text-bleu2 mb-4">
                {t('contact.info.title')}
              </h2>
              <div className="space-y-4 text-gray-700">
                <div className="flex items-start">
                  <BuildingIcon className="w-6 h-6 mr-3 mt-0.5 text-bleu1 flex-shrink-0" />
                  <div>
                    <p className="font-semibold">{t('contact.info.company')}</p>
                    <p className="text-sm">{t('contact.info.companyName')}</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <LocationIcon className="w-6 h-6 mr-3 mt-0.5 text-bleu1 flex-shrink-0" />
                  <div>
                    <p className="font-semibold">{t('contact.info.address')}</p>
                    <p className="text-sm">{t('contact.info.location')}</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <MailIcon className="w-6 h-6 mr-3 mt-0.5 text-bleu1 flex-shrink-0" />
                  <div>
                    <p className="font-semibold">{t('contact.info.email')}</p>
                    <a 
                      href={`mailto:${t('terms.legalNotice.publisher.contact')}`} 
                      className="text-sm text-bleu1 hover:underline"
                    >
                      {t('terms.legalNotice.publisher.contact')}
                    </a>
                  </div>
                </div>
              </div>
            </section>

            {/* Section pour nous contacter */}
            <section className="pt-6 border-t">
              <h2 className="text-h2 text-bleu2 mb-4">
                {t('contact.form.title')}
              </h2>
              <p className="text-gray-700 mb-4">
                {t('contact.form.description')}
              </p>
              <a
                href={`mailto:${t('terms.legalNotice.publisher.contact')}`}
                className="inline-block bg-bleu1 text-white py-3 px-6 rounded-lg font-medium hover:bg-bleu3 transition-colors"
              >
                {t('contact.form.sendEmail')}
              </a>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
